import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { FestivalServiceService } from 'src/app/admin/services/festival/festival-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-add-festival',
    templateUrl: './add-festival.component.html',
    styleUrls: ['./add-festival.component.scss'],
    standalone: false
})
export class AddFestivalComponent implements OnInit {

  constructor(
    private userdata: UserdataService,
    private toast: ToastrService,
    private festivalService: FestivalServiceService,
    private route: Router
  ) { }
  
  formGroup: UntypedFormGroup = new UntypedFormGroup({
    userId: new UntypedFormControl('', [Validators.required]),
    festivalName: new UntypedFormControl('', Validators.required),
    festivalDescription: new UntypedFormControl('', Validators.required),
    metaDescription: new UntypedFormControl(''),
    metaTags: new UntypedFormControl(''),
    metaKeywords: new UntypedFormControl(''),
    festivalImage: new UntypedFormControl('', Validators.required),
  });

  ngOnInit(): void {
    this.formGroup.patchValue({ userId: this.userdata.getId() })
  }

  get f() {
    return this.formGroup.controls
  }

  /**
   * Festival Image
   */
   imageError: string = ''
   imageSrc = ''
   public onBannerUpload(event: any){
     this.imageError = ''
     const reader = new FileReader();
     if(event.target.files && event.target.files.length) {
       const allowed_types = ['image/png', 'image/jpeg'];
             const max_height = 540;
             const max_width = 960;
       if (!_.includes(allowed_types, event.target.files[0].type)) {
         this.imageError = 'Only Images are allowed ( JPG | PNG )';
         return;
       }
       const [file] = event.target.files;
 
       reader.readAsDataURL(file);    
 
       reader.onload = (e:any) => {
         this.imageSrc = reader.result as string;    
         const image = new Image();
         image.src = e.target.result;
         image.onload = (rs:any) => {
           const img_height = rs.currentTarget['height'];
           const img_width = rs.currentTarget['width'];
           //console.log(img_height, img_width);
           if (img_height != max_height || img_width != max_width) {
               this.imageError =
                   'Image dimentions allowed ' +
                   max_width +
                   ' X ' +
                   max_height +
                   'px';
               return;
           } else {
             this.formGroup.patchValue({
              festivalImage: event.target.files[0]
             })
           }
         }
       };
     }
   }

  addFestivalSubmit(){
    const data = new FormData()
    data.append("userId", this.formGroup.get("userId")?.value)
    data.append("festivalName", this.formGroup.get("festivalName")?.value)
    data.append("festivalDescription", this.formGroup.get("festivalDescription")?.value)
    data.append("metaDescription", this.formGroup.get("metaDescription")?.value)
    data.append("metaTags", this.formGroup.get("metaTags")?.value)
    data.append("metaKeywords", this.formGroup.get("metaKeywords")?.value)
    data.append("festivalImage", this.formGroup.get("festivalImage")?.value)
    this.festivalService.addFestival(data).subscribe(
      (res:any) =>{
        this.toast.success(res.message,'Success')
        this.route.navigateByUrl('/admin/festival/list')
      },err=>{
        this.toast.error(err.error.message,'Error')
      }
    )
  }

}
